<div class="modal custom-modal" id="groomingPlanModal" tabindex="-1" role="dialog"
  aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div
    class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl zoomIn animated modal-wizard modal-bg-blue"
    role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title-custom text-info">Grooming Plan Purchase</h5>
        <button type="button" class="close btn-close" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div class="modal-body  main-modal">
        <div class="wizard custom-plan-list">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" (navChange)="changeTab($event)"
            class="nav-tabs nav nav-tabs justify-content-start border-0 w-100 flex-nowrap px-2 px-md-0 pb-2 pb-md-0">
            <li [ngbNavItem]="'tab1'" class="flex-fill" id="tab1">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-3 d-none d-lg-block">Pet</h6>
                <div class="count">
                  @if(isRightMarkForFirst){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>01</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Pet</h4>
                <div class="tab-pane custom-plan-list mt-lg-5">
                  <h6 class="text-primary">Pet Selection</h6>
                  <div class="row">
                    <div class="col-lg-6 mb-4">
                      <ng-select [disabled]="petDetail && planDetail" class="form-control input-select w-100"
                        [placeholder]="'Select Your Pet'" [items]="userPets" notFoundText="No Pet Exist"
                        bindLabel="name" bindValue="id" [searchable]="false" dropdownPosition="bottom"
                        [(ngModel)]="selectedPetId" [ngModelOptions]="{ standalone: true }"
                        (change)="changePetSelection()">
                      </ng-select>
                    </div>
                    @if (petSizeList?.length) {
                    <div class="col-lg-6">
                      <ng-select class="form-control input-select w-100" [items]="petSizeList"
                        [placeholder]="'Select Pet Size'" bindLabel="title" bindValue="id" [searchable]="false"
                        dropdownPosition="bottom" [(ngModel)]="selectedPetSize" [ngModelOptions]="{ standalone: true }"
                        (change)="changePetSizeSelection()">
                      </ng-select>
                      @if (validatePetSize && !selectedPetSize) {
                      <span class="text-danger error">Pet's size is required</span>
                      }
                    </div>
                    }
                  </div>
                  <div class="d-flex justify-content-end mt-4">
                    <a (click)="goToNext('plan')" class="btn btn-success cursor-pointer">Continue</a>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="'tab2'" class="flex-fill" id="tab2" [disabled]="activeTabs.includes('plan')"
              [ngClass]="{ disabled: activeTabs.includes('plan') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-3 d-none d-lg-block">Plan</h6>

                <div class="count">
                  @if(isRightMarkForSecond){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>02</span>
                  }
                </div>
              </button>
              <!-- addons plan section -->
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Plan</h4>
                <div class="tab-pane addons-section mt-lg-5">
                  <div>
                    <h6 class="text-primary">Pricing You Will Love</h6>
                    <p>Here is a detail of your grooming option which will match your need.</p>
                  </div>
                  <div class="row">
                    @if (planDetail && petDetail) {
                    @if (selectedGroomingPlan) {
                    <div class="col-12 mb-4">
                      <div class="custom-plan-box shadow-box d-flex flex-column position-relative overflow-hidden">
                        <h6 class="text-dark d-flex align-items-center flex-wrap mt-2">
                          {{ selectedGroomingPlan?.name }}
                          &nbsp;
                          @if (selectedGroomingPlan?.is_express_grooming) {
                          <span class="position-absolute top-0 end-0 badge ng-star-inserted">
                            Express Grooming
                          </span>
                          }
                        </h6>
                        <span class="groomer-rating">
                          @if (selectedGroomingPlan?.review?.total_review > 0) {
                          <app-star-rating [maxScore]="5" [score]="selectedGroomingPlan?.review?.ratting"
                            [forDisplay]="true">
                          </app-star-rating>&nbsp;({{ selectedGroomingPlan?.review?.total_review }}) }
                        </span>

                        @if (selectedGroomingPlan?.is_previous_plan) {
                        <span class="previous-selected-plan">
                          This plan was previously selected for grooming
                        </span>
                        }
                        <div class="description-height">
                          {{ selectedGroomingPlan?.description?.length > 180
                          ? (selectedGroomingPlan?.description
                          | slice : 0 : 160) + "..."
                          : selectedGroomingPlan?.description
                          }}
                          @if (selectedGroomingPlan?.description?.length > 180) {
                          <a href="javascript:void(0)" class="link-info link"
                            (click)="showDescription( 'Description', selectedGroomingPlan?.HTMLDescription)">Read
                            More</a>
                          }

                        </div>
                        <div class="mt-auto">
                          <hr>
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="price h6 text-info mb-0 fw-bold"> {{ selectedGroomingPlan?.price |
                              currency}} </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    }@else{
                    <span>Selected Grooming Plan Is Not Available</span> }

                    }@else {
                    @for (plan of groomingPlanList; track plan;let i = $index) {
                    <div class="col-12 mb-4">
                      <div class="custom-plan-box shadow-box d-flex flex-column position-relative overflow-hidden">
                        <h6 class="text-dark d-flex align-items-center flex-wrap mt-2">
                          {{ plan?.name }}
                          &nbsp;
                          @if (plan?.is_express_grooming) {
                          <span class="position-absolute top-0 end-0 badge ng-star-inserted">
                            Express Grooming
                          </span>
                          }
                        </h6>

                        <span class="groomer-rating">
                          @if (plan?.review?.total_review > 0) {
                          <app-star-rating [maxScore]="5" [score]="plan?.review?.ratting" [forDisplay]="true">
                          </app-star-rating>&nbsp;({{ plan?.review?.total_review }}) }
                        </span>

                        @if (plan?.is_previous_plan) {
                        <span class="previous-selected-plan">
                          This plan was previously selected for grooming
                        </span>
                        }
                        <div class="description-height">
                          {{
                          plan?.description.length > 180
                          ? (plan?.description | slice : 0 : 160) + "..."
                          : plan?.description
                          }}
                          @if (plan?.description.length > 180) {
                          <a href="javascript:void(0)" class="text-info link"
                            (click)="showDescription( 'Description', plan?.HTMLDescription)">Read More</a>
                          }
                        </div>
                        <div class="mt-auto">
                          <hr>
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="price h6 text-info mb-0 fw-bold">
                              {{plan?.price | currency}}
                            </div>
                            <a href="javascript:void(0)" (click)="selectGroomingPlan(plan)" [ngClass]="{
                              disabled: !plan?.is_available_for_outpost,
                              'btn-primary': selectedGroomingPlan?.id == plan?.id,
                              'btn-outline-success':
                                selectedGroomingPlan?.id !== plan?.id
                            }" class="btn">
                              Book@if (selectedGroomingPlan?.id == plan?.id){ed }
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                    }

                  </div>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a class="btn btn-outline-success cursor-pointer" (click)="goToPrev()">Previous</a>
                    <a class="btn btn-success cursor-pointer" (click)="goToNext('addons')">Continue</a>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="'tab3'" class="flex-fill" id="tab3" [disabled]="activeTabs.includes('addons')"
              [ngClass]="{ disabled: activeTabs.includes('addons') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-3 d-none d-lg-block">Add Ons</h6>
                <div class="count">
                  @if(isRightMarkForThird){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>03</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Add Ons</h4>
                <div class="tab-pane date-grooming-accordian mt-lg-5">
                  <div>
                    <h6 class="text-primary">Add-ons that add stars to your plan</h6>
                    <p>Add-on service show how much you care. Select from our wide-range of additional services.
                    </p>
                  </div>
                  <div class="row">
                    @for (addon of groomingAddonList; track addon; let i = $index) {
                    <div class="col-xl-4 col-lg-6 mb-4" [ngClass]="{
                      'plancard-selected': selectedServices.includes(addon.id)
                    }">
                      <div class="custom-plan-box shadow-box d-flex flex-column position-relative overflow-hidden">
                        <h6 class="text-dark d-flex align-items-center flex-wrap mt-2">{{addon?.title}}</h6>
                        @if (addon?.is_previous_addon) {
                        <span class="previous-selected-plan">This add-on was
                          previously selected</span>
                        }
                        <div class="description-height">
                          {{
                          addon?.description.length > 45
                          ? (addon?.description | slice : 0 : 45) + "..."
                          : addon?.description
                          }}
                          @if (addon?.description?.length > 45) {
                          <a href="javascript:void(0)" class="text-info link" (click)="
                            showDescription(
                              addon?.title,
                              addon?.description
                            )
                          ">Read More</a>
                          }

                        </div>
                        <div class="mt-auto">
                          <hr>
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="price h6 text-info mb-0"> {{ addon?.price | currency}} </div>
                            <a href="javascript:void(0)" class="btn" [ngClass]=" {'btn-success':
                              selectedServices.includes(addon?.id),'btn-outline-success':
                              !selectedServices.includes(addon?.id)}" (click)="selectServices(addon)">
                              {{
                              selectedServices.includes(addon?.id)
                              ? "Added"
                              : "Add"
                              }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a (click)="goToPrev()" class="btn btn-outline-success">Previous</a>
                    <a (click)="goToNext('date')" class="btn btn-success">Continue</a>
                  </div>
                </div>
              </ng-template>
            </li>

            <li [ngbNavItem]="'tab4'" class="flex-fill" id="tab4" [disabled]="activeTabs.includes('date')"
              [ngClass]="{ disabled: activeTabs.includes('date') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-3 d-none d-lg-block">Date</h6>
                <div class="count">
                  @if(isRightMarkForForth){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>04</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Date</h4>
                <div class="tab-pane date-grooming-accordian mt-lg-5">
                  <!-- Step 4 start -->
                  <h6 class="text-primary">Select Date For Grooming Your Pet</h6>
                  <div class="row">
                    <div class="col-12">
                      <div class="date-grooming-inner d-flex justify-content-center align-items-center border-0">
                        <div class="custom-calendar">
                          <p-calendar class="iconic-feild" placeholder="Click here to select grooming date"
                            [appendTo]="'body'" [(ngModel)]="groomingDate" [inline]="true" [minDate]="minDate"
                            [maxDate]="maxDate" [dateFormat]="pCalendarDateFormat" (onSelect)="selectGroomingDate()"
                            [readonlyInput]="true" [showIcon]="true" styleClass="p-calendar">
                            <ng-template pTemplate="date" let-date>
                              <div [ngStyle]="{color: checkDateForHoliday(date, 'date') ? '#9AB401' : (getSelectedDays(date) ? '#ffffff' : 'inherit'), 
                                  backgroundColor: getSelectedDays(date) ? '#6bb9ff' : 'inherit'}"
                                class="selected-inward" pTooltip="{{ checkDateForHoliday(date, 'tooltip') }}"
                                tooltipPosition="top">
                                {{ date.day }}
                              </div>
                            </ng-template>
                          </p-calendar>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a (click)="goToPrev()" class="btn btn-outline-success">Previous</a>
                    <a (click)="goToNext('groomers')" class="btn btn-success">Continue</a>
                  </div>
                  <!-- Step 4 end -->
                </div>
              </ng-template>
            </li>

            <li [ngbNavItem]="'tab5'" class="flex-fill" id="tab5"
              [disabled]="activeTabs.includes('groomers')||selectedGroomingPlan?.type == 'bathing'"
              [ngClass]="{ disabled: activeTabs.includes('groomers') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-3 d-none d-lg-block">Groomers</h6>
                <div class="count">
                  @if(isRightMarkForFifth){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>05</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Groomers</h4>
                <!-- Select Groomer section -->
                <div class="tab-pane date-grooming-accordian mt-lg-5">
                  <!-- Step 5 start -->
                  <h6 class="text-primary">Select Groomer</h6>
                  <div class="text-left mb-2">
                    @if (isPetPreviouslyGroomed && !isGroomerPreviouslySelected) {
                    <a href="javascript:void(0)" class="text-info">
                      <span (click)="onClickPreviousGroomer()">Want to select your pet's
                        previous groomer?</span>
                    </a>
                    }
                  </div>
                  <div class="row">
                    @for (groomer of groomerList; track $index) {
                    <div class="col-xl-4 col-lg-6 mb-4 cursor-pointer">
                      <div class="plan-inner-box shadow-box" (click)="selectGroomer(groomer)" [ngClass]="{
                        selected: selectedGroomer?.id == groomer?.id
                      }">
                        <div class="d-flex align-items-center mb-4 me-4">
                          @if (groomer?.image) {
                          <div class="img-box">
                            <img [src]="imagePath + groomer?.image" alt="groomer img" />
                          </div>

                          }@else {

                          <div class="img-box">
                            <ngx-avatars bgColor="{{ avatar_bg_color }}" fgColor="{{ avatar_fg_color }}"
                              name="{{ groomer.name }}" textSizeRatio="2">
                            </ngx-avatars>
                          </div>
                          }
                          <h6 class="text-primary mb-0">
                            {{ groomer.name | titlecase }}
                            <span class="groomer-rating">
                              @if (groomer?.review?.total_review > 0) {
                              <app-star-rating [maxScore]="5" [score]="groomer?.review?.ratting" [forDisplay]="true">
                              </app-star-rating>&nbsp;({{ groomer?.review?.total_review }}) }
                            </span>
                          </h6>
                        </div>
                        @if (groomer.is_previous_groomer) {
                        <span class="plan-re-entry">Your pet was previously groomed by this groomer</span>
                        }
                        <div class="mt-2"><span class="text-info">Available Days :</span>
                          <span class="text-green">In {{ groomer.reporting_time | titlecase }}</span>
                        </div>
                        <div>
                          <ul class="avail-day d-flex flex-wrap gap-1">
                            @for (day of groomer.working_days; track $index) {
                            <li>
                              {{ day }}
                            </li>
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                    } @if (!groomerList?.length ) {
                    <div class="col-12">
                      <p class="text-center">
                        No Groomers Available For Selected Date
                      </p>
                    </div>

                    }

                  </div>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a (click)="goToPrev()" class="btn btn-outline-success">Previous</a>
                    <a (click)="goToNext(isMandatoryProducts?'products':'payment')" class="btn btn-success">Continue</a>
                  </div>
                  <!-- Step 5 end -->

                </div>
              </ng-template>
            </li>

            @if (isMandatoryProducts) {
            <li [ngbNavItem]="'tab6'" class="flex-fill" id="tab6" [disabled]="activeTabs.includes('products')"
              [ngClass]="{ disabled: activeTabs.includes('products') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-3 d-none d-lg-block">Mandatory Products</h6>
                <div class="count">
                  @if(isRightMarkForSixth){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>06</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Mandatory Products</h4>
                <!-- Step 6 start -->
                <div class="tab-pane mt-lg-5">
                  @for (data of mandatoryProductList; track $index) {
                  <h6 class="mb-3 text-primary">
                    Mandatory vaccinations for &nbsp;{{ data?.pet_name }}
                  </h6>

                  @if (data?.mandatory_products?.length) {
                  <div class="row grooming-modal-vaccination">
                    @for (product of data?.mandatory_products; track $index) {
                    <div class="col-12 col-lg-6 mb-4 vaccination-modal" (click)="selectvaccins(product)">
                      <div class="vaccination-box shadow-box cursor-pointer" [ngClass]="{
                        'plancard-selected': selectedProduct.includes( product?.id)}">
                        <div class="d-flex justify-content-between mb-2">
                          <div class="d-flex me-4">
                            <ngx-avatars class="rounded-3 img-box me-3 overflow-hidden"
                              [src]="productImagePath + product?.id + '/' + product?.cover_image" [round]="false">
                            </ngx-avatars>
                            <h6 class="text-primary">
                              {{ product?.title }}&nbsp;
                              @if(product?.has_service_in_subscription) {
                              <i class="fa fa-info-circle text-warning"
                                ngbTooltip="This product is already exist in subscription."></i>
                              }
                            </h6>
                          </div>
                          <div class="select-checkbox">
                            <input type="checkbox" id="check_{{ $index }}" class="form-check-input"
                              (click)="selectvaccins(product)" [checked]="selectedProduct.includes(product?.id)" />
                            <label for="check_{{ $index }}"></label>
                          </div>
                        </div>

                        <div class="detail">
                          <div class="d-flex justify-content-between mb-2 align-items-center">
                            <div class="text-info h5">
                              {{ product?.price | currency }}
                            </div>
                            @if (product?.delivery_time) {
                            <span class="badge badge-pill custom-badge badge-info mt-1 mb-1 pt-1"
                              [ngbTooltip]="'Last Delivery Date'">
                              {{ product?.delivery_time | date : format }}
                            </span>
                            }
                          </div>
                          <p class="mb-0">
                            {{
                            product?.description.length > 45
                            ? (product?.description | slice : 0 : 45) + "..."
                            : product?.description
                            }}
                            @if (product?.description.length > 45) {
                            <a href="javascript:void(0)" class="text-info link" (click)="
                                  $event.stopPropagation();
                                  showDescription(product?.title, product?.description)
                                ">Read More</a>
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  } @if (type === 'boarding') {
                  <hr />
                  } @if(!data?.mandatory_products?.length){
                  <div class="row justify-content-md-center">No any products found!</div>
                  } }
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a (click)="goToPrev()" class="btn btn-outline-success">Previous</a>
                    <a (click)="goToNext('payment')" class="btn btn-success">Continue</a>
                  </div>
                </div>
                <!-- Step 6 end -->
              </ng-template>
            </li>
            }

            <li [ngbNavItem]="isMandatoryProducts?'tab7':'tab6'" class="flex-fill"
              [id]="isMandatoryProducts?'tab7':'tab6'" [disabled]="activeTabs.includes('payment')"
              [ngClass]="{ disabled: activeTabs.includes('payment') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-3 d-none d-lg-block">Payment</h6>
                <div class="count">
                  <span>
                    @if (isMandatoryProducts) {
                    07
                    }@else {
                    06
                    }
                  </span>
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Payment</h4>
                <div class="tab-pane order-accordion-inner border-0 mt-lg-5">
                  <!-- Step 7 start -->
                  <div class="row">
                    <div class="col-lg-5 col-12">
                      <h6 class="text-dark mb-3">Order Summary</h6>
                      <div class="custom-summary-block box-modal">
                        <ul class="type-list">
                          <li>
                            <div class="type-name h6">Grooming Request</div>
                            <div class="type-value text-info">{{ selectedGroomingPlan?.name | titlecase }} </div>
                          </li>
                          <li>
                            <div class="type-name h6">Grooming Date</div>
                            <div class="type-value text-info"> {{ groomingDate | date : format }}</div>
                          </li>
                          <li>
                            <div class="type-name h6">Pet Name</div>
                            <div class="type-value text-info"> {{ groomingPetName | titlecase }} </div>
                          </li>
                          @if (selectedGroomingPlan?.type != 'bathing') {
                          <li class="ng-star-inserted">
                            <div class="type-name h6">Groomer name</div>
                            <div class="type-value text-info not-selected-groomer ng-star-inserted">
                              {{selectedGroomer?.name
                              ? (selectedGroomer?.name | titlecase)
                              : "Not Selected"}}
                            </div>
                          </li>
                          }
                        </ul>
                      </div>
                    </div>
                    <div class="col-lg-7 col-12 mt-lg-0 mt-4">
                      <h6 class="text-dark mb-3">Payment Summary</h6>
                      <div class="pay-block box-modal">
                        <ul class="type-list-main ng-star-inserted">
                          <li class="d-flex justify-content-between"><span class="type-name">Groom/Bath</span><span
                              class="type-value h6 text-primary">
                              {{priceCalculationFromApi?.plan_detail?.price | currency}}
                            </span>
                          </li>
                          @if (priceCalculationFromApi?.addon_detail?.length) {
                          <ul class="multiple-type-list ng-star-inserted">
                            <li class="multi-type-title"><span class="type-name">Add-ons</span></li>
                            @for (addon of priceCalculationFromApi?.addon_detail; track addon) {
                            <li class="d-flex justify-content-between ng-star-inserted">
                              <span class="type-name"><span class="t-name-desc">
                                  {{ addon?.title }}
                                </span>
                              </span>
                              <span class="type-value h6 text-primary">{{addon?.price | currency}}</span>
                            </li>
                            }
                          </ul>
                          }
                          @if (priceCalculationFromApi?.product_detail?.length) {
                          <ul class="multiple-type-list ng-star-inserted">
                            <li class="multi-type-title"><span class="type-name">Mandatory Products</span></li>
                            @for (product of priceCalculationFromApi?.product_detail; track product) {
                            <li class="d-flex justify-content-between ng-star-inserted">
                              <span class="type-name">
                                <span class="t-name-desc">
                                  {{product?.title}}
                                </span>
                              </span>
                              <span class="type-value h6 text-primary">
                                {{ product?.price | currency}}
                              </span>
                            </li>
                            }
                          </ul>
                          }
                          @if (
                          priceCalculationFromApi?.holiday_detail &&
                          priceCalculationFromApi?.holiday_detail?.title &&
                          priceCalculationFromApi?.holiday_detail?.amount
                          ) {
                          <ul class="multiple-type-list ng-star-inserted">
                            <li class="multi-type-title"><span class="type-name">Extra Charges</span></li>
                            <li class="d-flex justify-content-between ng-star-inserted">
                              <span class="type-name">
                                <span class="t-name-desc">
                                  {{priceCalculationFromApi?.holiday_detail?.title}}
                                </span>
                              </span>
                              <span class="type-value h6 text-primary">
                                {{ priceCalculationFromApi?.holiday_detail?.amount | currency}}
                              </span>
                            </li>
                          </ul>
                          }
                          <li class="d-flex justify-content-between"><span class="type-name">Total</span><span
                              class="type-value h6 text-primary">
                              {{priceCalculationFromApi?.total_price | currency}}
                            </span>
                          </li>
                          <li class="d-flex justify-content-between multi-type-title ng-star-inserted"><span
                              class="type-name">Applied Discount: <span class="credit-amount font-weight-bold">
                                {{priceCalculationFromApi?.discount_detail?.title}}
                              </span>
                            </span>
                            <span class="type-value credit-amount h6 text-primary">-{{
                              priceCalculationFromApi?.discount_amount | currency
                              }}</span>
                          </li>
                          <li class="d-flex justify-content-between"><span class="type-name text-info fw-bold">Total
                              Amount Due</span>
                            <span class="type-value h6 text-info fw-bold">
                              {{ priceCalculationFromApi?.payable_amount | currency}}
                            </span>
                          </li>
                        </ul>

                        <div class="advanced-form">
                          <div class="form-checkbox form-check my-3 py-3 px-sm-5">
                            <input type="checkbox" name="checkbox" id="advancePayCheckbox"
                              [(ngModel)]="is_advance_booking_amount" class="form-check-input">
                            <label for="advancePayCheckbox" class="form-check-label">
                              I would like to pay in advance for this booking
                            </label>
                          </div>
                          @if (is_advance_booking_amount) {
                          <div>
                            <input type="number" [(ngModel)]="updatedAmount"
                              (change)="calculateMinimumAmount(updatedAmount)" class="form-control"
                              placeholder="Amount ($)">
                            <small class="text-danger error">
                              @if (minimumPaymentFlag) {
                              Un-check above check-box to continue without
                              advance payment }
                              @if (maximumPaymentFlag) {
                              Advance Booking Amount should be less than or
                              equal to Total Amount
                              }
                            </small>
                          </div>
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a (click)="goToPrev()" class="btn btn-outline-success">Previous</a>
                    <a [disabled]="(is_advance_booking_amount && minimumPaymentFlag) ||(is_advance_booking_amount && maximumPaymentFlag)"
                      [ngClass]="{'disabled': (is_advance_booking_amount && minimumPaymentFlag) ||(is_advance_booking_amount && maximumPaymentFlag)}"
                      (click)="addToCartPlan()" [ladda]="cartProcess" class="btn btn-success">
                      {{ planDetail?.planEditMode ? "Update" : "Add To" }} Cart
                    </a>
                  </div>
                  <!-- Step 7 end -->
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
      </div>
    </div>
  </div>
</div>